var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal"},[_c('span',{staticClass:"close",on:{"click":function($event){return _vm.$emit('close')}}},[_vm._v("×")]),_c('img',{staticClass:"modal-content",attrs:{"src":_vm.url,"alt":_vm.caption},on:{"click":function($event){return _vm.$emit('close')}}}),_c('div',{attrs:{"id":"caption"}},[_vm._v(_vm._s(_vm.caption))])])
}
var staticRenderFns = []

export { render, staticRenderFns }